<template>
  <div>
    <validation-observer v-slot="{ passes }">
      <b-modal
        id="modal-pay-directly-to-client"
        ref="modal-pay-directly-to-client"
        centered
        :title="$t('DEBTIA_PAY_DIRECTLY_TO_CLIENT')"
        :ok-title="$t('DEBTIA_ADD')"
        :no-close-on-backdrop="true"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loader"
        :ok-disabled="loader || errorProblem || !clientBcCustomerId || clientBcCustomerId === ''"
        @show="resetModal"
        @hidden="resetModal"
        @ok.prevent="passes(submitHandler)"
      >
        <b-overlay
          id="overlay-background"
          :show="loader === true"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="md"
          spinner-variant="primary"
          spinner-medium
        >
          <b-alert
            v-if="!clientBcCustomerId || clientBcCustomerId === ''"
            variant="danger"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_INVALID_CLIENT_BC_CUSTOMER_ID') }}</span>
            </div>
          </b-alert>
          <b-alert
            v-if="errorMsg"
            variant="warning"
            show
          >
            <div class="alert-body">
              <span>{{ errorMsg }}</span>
            </div>
          </b-alert>
          <b-card
            aria-hidden="true"
            class="mb-0"
            title=""
          >
            <b-form
              ref="form"
              class="repeater-form"
            >
              <!-- Row Loop -->
              <b-row
                ref="row"
              >
                <b-col
                  md="12"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Amount"
                    rules="required|min_value:0"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_AMOUNT')"
                      label-for="amount"
                    >
                      <b-form-input
                        :id="'amount'"
                        v-model="amount"
                        type="number"
                        :placeholder="$t('DEBTIA_AMOUNT')"
                        min="0"
                        @change="validateAmount($event)"
                      />
                      <span
                        style="color: red;"
                      >{{ errors[0] }}</span>
                      <span
                        :id="'amount'"
                        style="color: red; display: none;"
                      />
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-overlay>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BRow, BCol, BFormGroup,
  BForm,
  BFormInput,
  BAlert, BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { min_value } from 'vee-validate/dist/rules'

extend('min_value', min_value)

export default {
  components: {
    BCard,
    BOverlay,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    clickChange: {
      type: Boolean,
      required: true,
    },
    getStatements: {
      type: Function,
      required: true,
    },
    clientBcCustomerId: {
      type: [Number, String, null],
      default: null,
    },
  },
  data() {
    return {
      loader: false,
      required,
      min_value,
      errorMsg: '',
      errorProblem: false,
      amount: 0,
    }
  },
  watch: {
    modalLoads: {
      handler() {
        this.loader = this.modalLoads
      },
    },
    clickChange: {
      handler() {
      },
    },
  },
  created() {
  },
  methods: {
    validateAmount(amount) {
      this.errorMsg = ''
      this.errorProblem = false
      if (Number(amount) <= 0) {
        this.errorMsg = this.$t('DEBTIA_AMOUNT_MUST_BE_GREATER_THAN_ZERO')
        this.errorProblem = true
      }
    },
    resetModal() {
      this.errorMsg = ''
      this.errorProblem = false
      this.amount = ''
    },
    submitHandler() {
      if (!this.clientBcCustomerId || this.clientBcCustomerId === '') {
        this.errorMsg = this.$t('DEBTIA_INVALID_CLIENT_BC_CUSTOMER_ID')
      }
      return new Promise((resolve, reject) => {
        this.loader = true
        this.errorMsg = ''
        const url = '/debt-cases/statements/add-paid-amount'
        const data = []
        data.paidAmount = this.amount
        data.debt_case_id = this.caseId
        const amountData = { ...data }
        axios.post(url, amountData).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.$refs['modal-pay-directly-to-client'].hide()
            this.getStatements()
            setTimeout(() => {
              EventBus.$emit('refreshBetalingInvoices')
              EventBus.$emit('refreshPaymentsWidget')
            }, 500)
          }
        }).catch(error => {
          this.errorMsg = error.response.data.message ? this.$t(error.response.data.message) : error.message
          this.loader = false
          reject()
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
